(function () {
    const selectors = {
        section: ".js-pdp-reviews",
        slider: ".js-pdp-reviews-slider",
        slide: ".js-pdp-reviews-slide",
        sliderButtons: ".js-pdp-reviews-slider-buttons",
        prevButton: ".js-pdp-reviews-prev-button",
        nextButton: ".js-pdp-reviews-next-button"
    };

    const classes =  {
      hidden: "hidden"
    };

    const breakpoints = {
        medium: "(max-width: 1199px)",
        extraSmall: "(max-width: 767px)"
    };

    let sections = [];
    const MEDIUM_SCREEN = window.matchMedia(breakpoints.medium);
    const EXTRA_SMALL_SCREEN = window.matchMedia(breakpoints.extraSmall);

    function init() {
        sections = [...document.querySelectorAll(selectors.section)];

        sections.forEach(section => {
            const slider = section.querySelector(selectors.slider);
            const sliderButtons = section.querySelector(selectors.sliderButtons);

            if (!slider) return;

            initSlider(slider, sliderButtons);
        });
    }

    function initSlider(slider, sliderButtons) {
        let swiperInstance = null;
        const slides = [...slider.querySelectorAll(selectors.slide)];
        const options = {
            grabCursor: true,
            slidesPerView: "auto",
            spaceBetween: 16,
            loop: false,
            breakpoints: {
                /*1700: {
                    slidesPerView: 3,
                    spaceBetween: 16
                },*/
                376: {
                    slidesPerView: "auto",
                    spaceBetween: 16
                }
            },
            navigation: {
                prevEl: selectors.prevButton || null,
                nextEl: selectors.nextButton || null
            }
        };

        function changeSliderStateOnBreakpoint() {
            if (
                (EXTRA_SMALL_SCREEN.matches && slides.length > 1) ||
                (MEDIUM_SCREEN.matches && slides.length > 2) ||
                (!MEDIUM_SCREEN.matches && slides.length > 3)
            ) {
                sliderButtons && sliderButtons.classList.remove(classes.hidden);

                if (!swiperInstance) swiperInstance = new Swiper(slider, options);
            } else {
                sliderButtons && sliderButtons.classList.add(classes.hidden);

                if (!swiperInstance) return;

                swiperInstance.destroy();
                swiperInstance = null;
                slider.classList.remove("swiper-backface-hidden");
            }
        }

        window.addEventListener("resize", changeSliderStateOnBreakpoint);
        changeSliderStateOnBreakpoint();
    }

    init();
})();
